import { type BlockFilters } from '@reliance/types/filters/BlockFilters';
import { type Block } from '@reliance/types/models/Block';
import { type PaginatedResponse } from '@reliance/types/responses/PaginatedResponse';
import { type ApiSuccessResponse, type ApiService } from '../types/ApiService';

export type BlockCreateRequest = {
  phoneNumber: string;
  description: string;
  requestedBy?: string;
  category?: string;
  type?: string;
  facilityId?: number;
  externalFacilityId?: string;
  dateUnblocked?: string | null;
};

export type BlockAddingBlockRequest = {
  type: string;
  reason?: string;
};

export type BlockRemovingBlockRequest = {
  id: number;
  type?: string;
  reason?: string;
};

export type BlockUpdateRequest = {
  phoneNumber: string;
  requestedBy: string;
  reason?: string;
  removingBlocks?: BlockRemovingBlockRequest[];
  addingBlocks?: BlockAddingBlockRequest[];
  dateUnblocked?: string | null;
};

export type BlockDeleteParams = {
  reason?: string;
  name?: string;
  facilityBlockId?: number;
  blockId?: number;
};

type BlockIndexApiResponse = PaginatedResponse<Block> & {
  blocks?: Block[];
};

export const block = (centralApi: ApiService) => ({
  index: (
    params?: Partial<BlockFilters>,
  ): Promise<PaginatedResponse<Block>> => {
    return centralApi
      .get<BlockIndexApiResponse>('/block/by-account', { params })
      .then((response) => {
        if (response.data === undefined && response.blocks !== undefined) {
          return { ...response, data: response.blocks };
        }
        return response;
      });
  },
  post: (data: BlockCreateRequest): Promise<ApiSuccessResponse<void>> => {
    return centralApi.post('/block', data);
  },
  put: (data: BlockUpdateRequest): Promise<ApiSuccessResponse<void>> => {
    return centralApi.put('/block', data);
  },
  delete: (ani: string, params: BlockDeleteParams): Promise<boolean> => {
    return centralApi.delete(`/block/${ani}`, { params });
  },
});
